// function to find time-ago value of resume view based on createdOn
export const getTimeAgo = (createdOn: string) => {
  // Parse the createdOn date string
  const currentTime = new Date();
  const createdTime = new Date(createdOn);

  // Calculate the difference in milliseconds
  const timeDifference = currentTime.getTime() - createdTime.getTime();

  // Define the time divisions in milliseconds
  const seconds = Math.floor(timeDifference / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);
  const weeks = Math.floor(days / 7);
  const months = Math.floor(days / 30); // Approximate number of days in a month
  const years = Math.floor(days / 365);

  // Return the time ago value in appropriate units
  if (years > 0) {
    return `${years} yr${years > 1 ? "s" : ""} ago`;
  } else if (months > 0) {
    return `${months} mth${months > 1 ? "s" : ""} ago`;
  } else if (weeks > 0) {
    return `${weeks} wk${weeks > 1 ? "s" : ""} ago`;
  } else if (days > 0) {
    return `${days} day${days > 1 ? "s" : ""} ago`;
  } else if (hours > 0) {
    return `${hours} hr${hours > 1 ? "s" : ""} ago`;
  } else if (minutes > 0) {
    return `${minutes} min${minutes > 1 ? "s" : ""} ago`;
  } else {
    return `${seconds} second${seconds > 1 ? "s" : ""} ago`;
  }
};

export const getDuration = (duration: number) => {
  if (duration === null) {
    return "0 min";
  }
  // function to convert duration in seconds to valid printable format
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const seconds = duration % 60;

  // Return the duration in appropriate format
  return `${hours > 0 ? hours + "hr" : ""} ${
    minutes > 0 ? minutes + "min" : ""
  } ${seconds > 0 ? seconds + "sec" : ""}`;
};
